





import Vue from 'vue'

export default Vue.extend({
  name: 'ActiveCellRendererDX',

  props: {
    status: Number,
  },

  computed: {
    icon (): string {
      // @ts-ignore
      return this.status !== 3 ? 'check' : 'clear'
    },

    color (): string {
      // @ts-ignore
      return this.status !== 3 ? 'green' : 'red'
    }
  }
})
